module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rt-view', [_c('rt-header', [_c('rt-detail-header', [_c('rt-header-icon', {
    attrs: {
      "slot": "icon",
      "icon": "rt-base-account"
    },
    slot: "icon"
  }), _vm._v(" "), _c('rt-header-title', {
    attrs: {
      "title": '变更申请详情',
      "sub-title": ""
    }
  }), _vm._v(" "), _c('template', {
    slot: "btn"
  }, [_c('rt-button', {
    staticClass: "add-button",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "approve-progress"
    },
    on: {
      "click": function($event) {
        return _vm.approvalProgress()
      }
    }
  }, [_vm._v("审批进度")])], 1)], 2)], 1), _vm._v(" "), _c('rt-content', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.orderLoading),
      expression: "orderLoading"
    }]
  }, [_c('rt-form', {
    ref: "channelOrderRef",
    attrs: {
      "model": _vm.Model,
      "label-width": "120px"
    }
  }, [_c('rt-section', {
    attrs: {
      "title": "基本信息",
      "icon": "rt-portal-SALESMANAGEMENT"
    }
  }, [_c('rt-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "变更申请详情单号",
      "prop": "new_name"
    }
  }, [_c('rt-input', {
    attrs: {
      "showLabel": "true",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_name),
      callback: function($$v) {
        _vm.$set(_vm.Model, "new_name", $$v)
      },
      expression: "Model.new_name"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "创建时间",
      "prop": "createdon"
    }
  }, [_c('rt-input', {
    attrs: {
      "showLabel": "true",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.createdon),
      callback: function($$v) {
        _vm.$set(_vm.Model, "createdon", $$v)
      },
      expression: "Model.createdon"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "取消原因",
      "prop": "new_cancel_reason"
    }
  }, [_c('rt-input', {
    attrs: {
      "showLabel": "true",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_cancel_reason),
      callback: function($$v) {
        _vm.$set(_vm.Model, "new_cancel_reason", $$v)
      },
      expression: "Model.new_cancel_reason"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "订单号",
      "prop": "new_saleorder_id"
    }
  }, [_c('rt-lookup', {
    attrs: {
      "lookup-style": "single",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_saleorder_id),
      callback: function($$v) {
        _vm.$set(_vm.Model, "new_saleorder_id", $$v)
      },
      expression: "Model.new_saleorder_id"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "商机名称",
      "prop": "new_opportunity_idsj"
    }
  }, [_c('rt-lookup', {
    attrs: {
      "lookup-style": "single",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_opportunity_idsj),
      callback: function($$v) {
        _vm.$set(_vm.Model, "new_opportunity_idsj", $$v)
      },
      expression: "Model.new_opportunity_idsj"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "下级渠道",
      "prop": "new_account_idqd"
    }
  }, [_c('rt-lookup', {
    attrs: {
      "lookup-style": "single",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_account_idqd),
      callback: function($$v) {
        _vm.$set(_vm.Model, "new_account_idqd", $$v)
      },
      expression: "Model.new_account_idqd"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "总代所属销售",
      "prop": "new_agentsales_id"
    }
  }, [_c('rt-lookup', {
    attrs: {
      "lookup-style": "single",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_agentsales_id),
      callback: function($$v) {
        _vm.$set(_vm.Model, "new_agentsales_id", $$v)
      },
      expression: "Model.new_agentsales_id"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "负责人",
      "prop": "ownerid"
    }
  }, [_c('rt-lookup', {
    attrs: {
      "lookup-style": "single",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.ownerid),
      callback: function($$v) {
        _vm.$set(_vm.Model, "ownerid", $$v)
      },
      expression: "Model.ownerid"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "更新订单结果",
      "prop": "new_order_result"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_order_result.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_order_result, "text", $$v)
      },
      expression: "Model.new_order_result.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "订单类型",
      "prop": "new_ord_type_id"
    }
  }, [_c('rt-lookup', {
    attrs: {
      "lookup-style": "single",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_ord_type_id),
      callback: function($$v) {
        _vm.$set(_vm.Model, "new_ord_type_id", $$v)
      },
      expression: "Model.new_ord_type_id"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "更新渠道订单结果",
      "prop": "new_channel_order_result"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_channel_order_result.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_channel_order_result, "text", $$v)
      },
      expression: "Model.new_channel_order_result.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "是否使用电子签章",
      "prop": "new_use_electronic_signature"
    }
  }, [_c('rt-input', {
    attrs: {
      "showLabel": "true",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_use_electronic_signature),
      callback: function($$v) {
        _vm.$set(_vm.Model, "new_use_electronic_signature", $$v)
      },
      expression: "Model.new_use_electronic_signature"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "更新库存产品占用明细结果",
      "prop": "new_product_occupancy_result"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_product_occupancy_result.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_product_occupancy_result, "text", $$v)
      },
      expression: "Model.new_product_occupancy_result.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "最终客户",
      "prop": "new_end_customer"
    }
  }, [_c('rt-input', {
    attrs: {
      "showLabel": "true",
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_end_customer),
      callback: function($$v) {
        _vm.$set(_vm.Model, "new_end_customer", $$v)
      },
      expression: "Model.new_end_customer"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "更新软件实际发货数量结果",
      "prop": "new_actual_shipment_result"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_actual_shipment_result.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_actual_shipment_result, "text", $$v)
      },
      expression: "Model.new_actual_shipment_result.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "审批状态",
      "prop": "new_approvalstatus"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_approvalstatus.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_approvalstatus, "text", $$v)
      },
      expression: "Model.new_approvalstatus.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "更新渠道发货单结果",
      "prop": "new_channel_shipment_result"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_channel_shipment_result.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_channel_shipment_result, "text", $$v)
      },
      expression: "Model.new_channel_shipment_result.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "更新过单点结果",
      "prop": "new_order_point_result"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_order_point_result.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_order_point_result, "text", $$v)
      },
      expression: "Model.new_order_point_result.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "状态",
      "prop": "statecode"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.statecode.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.statecode, "text", $$v)
      },
      expression: "Model.statecode.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "释放stockunit结果",
      "prop": "new_stockunit_result"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_stockunit_result.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_stockunit_result, "text", $$v)
      },
      expression: "Model.new_stockunit_result.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "释放返利结果",
      "prop": "new_rebate_result"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_rebate_result.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_rebate_result, "text", $$v)
      },
      expression: "Model.new_rebate_result.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "更新内部交易单结果",
      "prop": "new_transaction_result"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_transaction_result.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_transaction_result, "text", $$v)
      },
      expression: "Model.new_transaction_result.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "同步WMS状态",
      "prop": "new_sync_wms_status"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_sync_wms_status.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_sync_wms_status, "text", $$v)
      },
      expression: "Model.new_sync_wms_status.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "同步EBS发货单状态",
      "prop": "new_sync_ebs_shipment_status"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_sync_ebs_shipment_status.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_sync_ebs_shipment_status, "text", $$v)
      },
      expression: "Model.new_sync_ebs_shipment_status.text"
    }
  })], 1)], 1), _vm._v(" "), _c('rt-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('rt-form-item', {
    attrs: {
      "label": "同步EBS订单状态",
      "prop": "new_sync_ebs_order_status"
    }
  }, [_c('rt-picklist', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.Model.new_sync_ebs_order_status.text),
      callback: function($$v) {
        _vm.$set(_vm.Model.new_sync_ebs_order_status, "text", $$v)
      },
      expression: "Model.new_sync_ebs_order_status.text"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('rt-section', {
    attrs: {
      "title": "订单变更申请产品",
      "icon": "rt-portal-SALESMANAGEMENT"
    }
  }, [_c('rt-row', [_c('rt-col', {
    attrs: {
      "span": 24
    }
  }, [_c('rt-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "tooltip-effect": "dark",
      "sectionable": false,
      "showPagination": false,
      "need-fetch": false,
      "no-needfetch-data": _vm.Model.oclist
    }
  }, [_c('rt-table-column', {
    attrs: {
      "label": "编号",
      "prop": "new_name"
    }
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "变更申请单号",
      "prop": "new_change_application_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_change_application_id ? scope.row.new_change_application_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "订单产品行号",
      "prop": "new_ord_saleorderdetail_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_ord_saleorderdetail_id ? scope.row.new_ord_saleorderdetail_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "发货产品行号",
      "prop": "new_invoice_product_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_invoice_product_id ? scope.row.new_invoice_product_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "发货单号",
      "prop": "new_ord_shipment_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_ord_shipment_id ? scope.row.new_ord_shipment_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "产品名称",
      "prop": "new_product_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_product_id ? scope.row.new_product_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "业务群",
      "prop": "new_productgroup_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_productgroup_id ? scope.row.new_productgroup_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "子产品线",
      "prop": "new_product_line"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_product_line) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "服务月份",
      "prop": "new_sevicemonths"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_sevicemonths) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "取消数量",
      "prop": "new_cancel_quantity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_cancel_quantity) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "交货数量",
      "prop": "new_delivery_quantity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_delivery_quantity) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "成交价",
      "prop": "new_current_rate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_current_rate) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "取消金额",
      "prop": "cancelAmount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.cancelAmount) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "是否涉及硬件实体交付",
      "prop": "new_involves_hardware_delivery"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_involves_hardware_delivery) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "src": require("../../assets/imgs/home/no-order.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "nodata-prompt"
  }, [_vm._v("\n                        Sorry！未找到相应结果哦~换个关键词试试！\n                    ")])])], 2)], 1)], 1)], 1), _vm._v(" "), _c('rt-section', {
    attrs: {
      "title": "订单变更申请POSKU明细",
      "icon": "rt-portal-SALESMANAGEMENT"
    }
  }, [_c('rt-row', [_c('rt-col', {
    attrs: {
      "span": 24
    }
  }, [_c('rt-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "tooltip-effect": "dark",
      "sectionable": false,
      "showPagination": false,
      "need-fetch": false,
      "no-needfetch-data": _vm.Model.opdlis
    }
  }, [_c('rt-table-column', {
    attrs: {
      "label": "编号",
      "prop": "new_name"
    }
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "变更申请单号",
      "prop": "new_order_change_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_order_change_id ? scope.row.new_order_change_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "产品",
      "prop": "new_product_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_product_id ? scope.row.new_product_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "变更产品行号",
      "prop": "new_change_product_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_change_product_id ? scope.row.new_change_product_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "产品POSKU",
      "prop": "new_posku_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_posku_id ? scope.row.new_posku_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "订单POSKU明细",
      "prop": "new_ord_saleorderline_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_ord_saleorderline_id ? scope.row.new_ord_saleorderline_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "子产品线",
      "prop": "new_subproductline_1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_subproductline_1) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "物料类别",
      "prop": "new_materialtype_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_materialtype_id ? scope.row.new_materialtype_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "服务月份",
      "prop": "new_smonths"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_smonths) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "成交价",
      "prop": "new_finalprice"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_finalprice) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "发货数量",
      "prop": "new_shipment_quantity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_shipment_quantity) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "取消数量",
      "prop": "new_cancel_quantity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_cancel_quantity) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "取消金额",
      "prop": "cancelAmount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.cancelAmount) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "发货单明细",
      "prop": "new_ord_shipmentline_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_ord_shipmentline_id ? scope.row.new_ord_shipmentline_id.name : '') + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "C SKU开票名称",
      "prop": "new_csku"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_csku) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "POSKU开票名称",
      "prop": "new_posku"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_posku) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('rt-table-column', {
    attrs: {
      "label": "税率",
      "prop": "new_taxrate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.new_taxrate) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "src": require("../../assets/imgs/home/no-order.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "nodata-prompt"
  }, [_vm._v("\n                        Sorry！未找到相应结果哦~换个关键词试试！\n                    ")])])], 2)], 1)], 1)], 1), _vm._v(" "), (_vm.id) ? _c('rt-file-list', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "can-upload": false,
      "approvalstatus": _vm.Model.new_approvalstatus,
      "can-delete": false,
      "moduleType": "new_ord_saleorder",
      "objectId": _vm.id,
      "icon": "rt-portal-FINANCIALMANAGEMENT",
      "title": _vm.Model.new_name
    }
  }) : _vm._e(), _vm._v(" "), _c('RtApprovalProgressDialog', {
    ref: "approvalDialog",
    attrs: {
      "entity-name": _vm.entityname,
      "entity-id": _vm.id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7284d850"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/new_order_change_application/new_order_change_applicationDetail.vue
// module id = 2123
// module chunks = 228